module.exports = __webpack_public_path__ + "static/media/armchair-fill.56bd5f8a.svg";